import type { ReactNode } from 'react';

export const symbol_swipe_up_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M338.5-218.5Q280-277 280-360q0-82 50.5-133.5T450-559v-207l-68 68q-9 9-21 9t-21-9q-9-9-9-21t9-21l119-119q5-5 10-7t11-2q6 0 11 2t10 7l119 119q9 9 9 21t-9 21q-9 9-21 9t-21-9l-68-68v207q69 14 119.5 65.5T680-360q0 83-58.5 141.5T480-160q-83 0-141.5-58.5ZM579-261q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41Zm-99-99Z"
		/>
	</svg>
);
